import { jsx as _jsx } from "react/jsx-runtime";
import { TextSkeleton } from '../skeleton';
export var SavedFilterSkeleton = function () {
    return (_jsx("div", { className: 'py-2 flex w-full h-full', children: [1, 2, 3].map(function (_, index) { return (_jsx(TextSkeleton, {}, index)); }) }));
};
